<template>
  <div>
    <div class="doc-row" :id="`doc-row-${doc.ID}`" v-for="doc in productDocs" :key="doc.ID">
      <div class="filename doc-td">
        <img class="fileext" :src="doc.FileExt | fileExtIcon" alt="">
        <span :data-ID="`${doc.ID}`" :title="`${doc.FileName}${doc.FileExt}`" class="filename-text">{{doc.FileName}}{{doc.FileExt}}</span>
      </div>
      <div class="filesize doc-td">{{doc.FileSize|fileSizeFormat}}</div>
      <div class="fileremark doc-td">{{doc.FileRemark || '-'}}</div>
      <btn-doc-down :doc="doc"></btn-doc-down>
    </div>
  </div>
</template>

<script>
import BtnDocDown from '../components/BtnDocDown.vue'

export default {
  inject: ['productDocs'],
  components: { BtnDocDown },
}
</script>

<style lang="less" scoped>
.doc-row {
    height: 40px;
    border-left: 1px solid #e7e7e7;

    /deep/ .doc-download{
      width: 16%;
      height: 40px;
      color: #0F8DF0;
    }
}

.doc-row:first-child>div {
    border-top: 1px solid #e7e7e7;
}
.doc-row .doc-td {
    float: left;
    font-size: 13px;
    line-height: 40px;
    border-right: 1px solid #e7e7e7;
    border-bottom: 1px solid #e7e7e7;
    height: 40px
}

.doc-row .filename {
    width: 50%;
    color: #333;
    padding-left: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 40px;
    padding-left: 30px;
    position: relative;
}

.doc-row .filename-text {
    cursor: pointer;
    float: left;
    max-width: 93%;
    display: inline-block;
    /* max-width: 90%; */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.doc-row .filename-text:hover {
    color: #0F8DF0;
}

.doc-row .fileext {
    width: 22px;
    min-width: 22px;
    height: 22px;
    position: absolute;
    left: 4px;
    top: 8px;
    float: left;
}

.doc-row .filesize {
    width: 10%;
    color: #555;
    text-align: center;
    height: 40px
}

.doc-row .fileremark {
    width: 24%;
    color: #555;
    padding: 0px 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 40px
}
</style>
